import React, { memo, useRef, useState } from 'react';
import { View, Platform } from 'react-native';
import { triggerHapticFeedback } from 'utils/hapticFeedback';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableBounce from 'utils/packages/TouchableBounce';
import { FREQUENCY } from 'features/subscriptions/utils/frequency';
import { Button } from 'design-system';
import { isWeb } from '../../../../constants';
const options = {
    enableVibrateFallback: false,
    ignoreAndroidSystemSettings: false,
};
const SubscriptionFrequencyModalContent = ({ paymentFrequency, onSelect, showSaveButton = false, title = 'Frequency', centeredTitle = false, }) => {
    const styles = useStyles(styleSet);
    const [selectedFrequency, setSelectedFrequency] = useState(paymentFrequency);
    const allowSaveEmpty = useRef(paymentFrequency !== undefined);
    const pressItem = (item) => () => {
        if (Platform.OS === 'ios') {
            triggerHapticFeedback('impactLight', options);
        }
        if (showSaveButton) {
            setSelectedFrequency(Number(item) === selectedFrequency
                ? undefined
                : Number(item));
        }
        else {
            onSelect(Number(item));
        }
    };
    return (<View style={[styles.header, centeredTitle && styles.centeredHeader]}>
      {!isWeb ? (<Text Text-24 style={styles.title}>
          {title}
        </Text>) : (<Spacer h={16}/>)}
      <View style={styles.itemContainer}>
        {Object.keys(FREQUENCY).map((key) => (<TouchableBounce key={key} onPress={pressItem(key)} hoverStyle={styles.buttonSelected} style={[
                styles.button,
                selectedFrequency === Number(key) ? styles.buttonSelected : {},
            ]}>
            {selectedFrequency === Number(key) ? (<Text Text-16 White>
                {FREQUENCY[Number(key)]}
              </Text>) : (<Text Text-16 Secondary>
                {FREQUENCY[Number(key)]}
              </Text>)}
          </TouchableBounce>))}
      </View>
      {!!showSaveButton && (<Button title="Save" onPress={() => onSelect(selectedFrequency)} disabled={!allowSaveEmpty.current && !selectedFrequency} brand style={styles.saveButton}/>)}
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    title: {
        ...(isWeb
            ? {
                marginVertical: rem(16),
            }
            : {
                marginBottom: rem(33),
                marginTop: rem(60),
            }),
    },
    header: {
        alignItems: 'flex-start',
        justifyContent: 'center',
    },
    centeredHeader: {
        alignItems: 'center',
    },
    itemContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    button: {
        backgroundColor: colors.background.dark,
        paddingVertical: rem(9),
        paddingHorizontal: rem(24),
        borderRadius: rem(24),
        marginEnd: rem(8),
        marginBottom: rem(16),
    },
    buttonSelected: {
        backgroundColor: colors.gradients.ultimate.colors[0],
    },
    saveButton: {
        marginTop: rem(16),
    },
}));
export default memo(SubscriptionFrequencyModalContent);
